module.exports = __webpack_public_path__ + "static/media/ebarchitects_kabeza20202.024872c2.jpg";